import React, {useEffect, useState} from 'react'
import {convertirNumeroConComas} from '../../../../utils/numbers.utils'
import TableDTE from '../../../../components/Tables/TableDTE/TableDTE'

const TablaFacturacionCF = (props: any) => {
  const [rows, setRows] = useState([])

  useEffect(() => {
    const productos = props.rows.map((p: any, i: number) => ({
      ...p,
      unidadMedida: p.unidadMedida,
      index: i,
      tipoNew: p.checkNoGravado ? "No Gravado" : p.tipo === "p" ? "Producto" : "Servicio",
      cantidadNew: p.cantidad,
      precioNew: `$${convertirNumeroConComas(p.precio)}`,
      cantidadDescuentoNew: `$${convertirNumeroConComas(p.cantidadDescuento)}`,
      ventasGravadas: p.checkNoGravado || props?.checkExentoImpuesto || props?.checkVentasNoSujetas ? "$0.00" : `$${convertirNumeroConComas(p.total)}`,
      ventasExentas: !p.checkNoGravado && props?.checkExentoImpuesto ? `$${convertirNumeroConComas(p.total)}` : "$0.00",
      ventasNoSujetas: !p.checkNoGravado && props?.checkVentasNoSujetas ? `$${convertirNumeroConComas(p.total)}` : "$0.00",
      checkNoGravado: p.checkNoGravado,
    }))
    setRows(productos)
  }, [props?.rows, props?.checkExentoImpuesto, props?.checkVentasNoSujetas])

  return (
    <><TableDTE rows={rows} openModalEliminar={props.openModalEliminar} openModalEditar={props.openModalEditar} sinAcciones={props?.sinAcciones} idDoc={props?.idDoc}/>
      <div className="cf-calculos-producto" style={{width: '100%'}}>
        <table>
          <tbody>
            <TableRowResponsiveCard text={`Suma de operaciones de ventas ${props?.checkExentoImpuesto ? "exentas" : props?.checkVentasNoSujetas ? "no sujetas" : "gravadas"}`} valor={(parseFloat(props?.datos?.total || '0') + parseFloat(props?.datos?.descuentoGlobal || '0')).toFixed(2)} className="cf-subtotal" />
            {parseFloat(props?.datos?.descuentoGlobal || '0') > 0 &&
              <tr className="cf-descuento">
                <td>Descuento global</td>
                <td>-${convertirNumeroConComas(props?.datos?.descuentoGlobal)}</td>
              </tr>
            }
            <TableRowResponsiveCard text={"Impuesto al Valor Agregado 13%"}  valor={props?.datos?.totalImpuesto1} className="cf-subtotal" />
            <TableRowResponsiveCard text={"Subtotal"}  valor={props?.datos?.subtotal} className="cf-subtotal" />
            <TableRowResponsiveCard text={"Otros impuestos"}  valor={props?.datos?.otrosImpuestos} className="cf-subtotal" />
            <TableRowResponsiveCard text={"IVA percibido 1%"}  valor={props?.datos?.totalIvaPercibido} className="cf-subtotal" />
            <TableRowResponsiveCard text={"IVA retenido 1%"}  valor={props?.datos?.totalImpuesto2} className="cf-subtotal" />
            <TableRowResponsiveCard  text={"Retención renta 10%"}  valor={props?.datos?.totalRetencionRenta} className="cf-descuento" />
            <TableRowResponsiveCard text={"Total Otros Montos No Afectados"}  valor={props?.datos?.totalNoGravado} className="cf-subtotal" />
            <TableRowResponsiveCard text={"Monto total a la operación"}  valor={props?.datos?.totalMontoOperacion} className="cf-total" />
            { props?.propina && props?.propina?.propina_activa &&
              <TableRowResponsiveCard  text={`Monto propina ${props?.propina?.cantidad_propina * 100}%`}  valor={ props?.checkPropina? (props?.datos?.totalMontoOperacion * props?.propina?.cantidad_propina): 0.00} className="cf-descuento" />
            }
          <TableRowResponsiveCard text={"Total"}  valor={props?.datos?.totalPagar} className="cf-total" />
          </tbody>
        </table>
      </div></>
  )
}

const TableRowResponsiveCard = (props: any) => {
  return (
    <tr className={props?.className}>
      <td>{props.text}</td>
      <td>${convertirNumeroConComas(props?.valor) ?? '0.00'}</td>
    </tr>
  )
}

export default TablaFacturacionCF
